import find from 'lodash/find';
import { uriMappings } from './config.json';

export const isCommerceSdk = (url) => {
  const pattern = /(?=.*commerce-widget)(?=.*sdk.min.js)(?=.*\.(active\.com|activenetwork\.com))/;
  return pattern.test(url);
};

export const getScriptOrigin = (src) => {
  const match = src.match(/(https?:\/\/[^/]+)/);
  return match ? match[1] : null;
};

export const getPresrcOfStaticResource = (src) => {
  return src && src.split('/sdk.min.js')[0];
};

export const getMappingBaseUris = (scriptOrigin) => {
  const uriMappingData = new Map(uriMappings);
  const uriMapping = uriMappingData.get(scriptOrigin);
  const nextVersion = process.env.VERSION;

  if (!uriMapping) {
    return { cdn: '' };
  }

  const cdnHost = uriMapping.cdn ? `${uriMapping.cdn}/${nextVersion}` : '';

  return { cdn: cdnHost };
};

export const getTargetScriptInfos = () => {
  const scripts = document.getElementsByTagName('script');

  const sdkUrlScript = find(scripts, (o) => {
    return isCommerceSdk(o.src.split('?')[0]);
  });

  if (!sdkUrlScript) return {};

  const sdkUrl = sdkUrlScript.src;

  const scriptOrigin = getScriptOrigin(sdkUrl);

  const mapppingBaseUri = getMappingBaseUris(scriptOrigin);
  const preUrlOfStaticResouce = mapppingBaseUri.cdn || getPresrcOfStaticResource(sdkUrl);

  return {
    preUrlOfStaticResouce,
  };
};
